import { DestructiveModal, Text, ValidationMessage } from '@modusign/design-system';
import { ReactNode } from 'react';

interface InPersonDestructiveModalLayoutProps {
  isLoading?: boolean;
  title: string;
  confirmButtonLabel: string;
  description: string;
  extraMessage?: string;
  onCancel: () => void;
  onConfirm: () => void;
  children: ReactNode;
}

export default function InPersonDestructiveModalLayout({
  isLoading,
  title,
  confirmButtonLabel,
  description,
  extraMessage,
  onCancel,
  onConfirm,
  children,
}: InPersonDestructiveModalLayoutProps) {
  return (
    <DestructiveModal
      closeButtonLabel="닫기"
      confirmButtonLabel={confirmButtonLabel}
      isLoading={isLoading}
      isOpen
      maxWidth="xs"
      title={title}
      onClose={onCancel}
      onConfirm={onConfirm}
    >
      <ValidationMessage marginTop="0" textAlign="center">
        <Text fontSize="md" fontWeight="medium">
          {description}
        </Text>
      </ValidationMessage>
      {extraMessage && (
        <Text fontSize="md" fontWeight="regular" mt={1} textAlign="center">
          {extraMessage}
        </Text>
      )}
      {children}
    </DestructiveModal>
  );
}
